import { CreateTaskMutationBody } from '@api';
import { mapTaskFormAudience, TaskFormSchemaType } from '@common';

type GetCreateTaskDataArgsType = {
  values: TaskFormSchemaType;
};

export const getCreateTaskData = ({
  values,
}: GetCreateTaskDataArgsType): CreateTaskMutationBody => ({
  title: values.title.trim(),
  description: values.description.trim(),
  priority: values.priority,
  context: values.context === '' ? null : values.context,
  audience: mapTaskFormAudience({ values }),
});
